import React from "react";

interface CardProps {
  children: React.ReactNode 
}

const Card: React.FC<CardProps> = ({ children  }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <div className="flex flex-col">{children}</div>
    </div>
  );
};
export default Card;